import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringProspectsTab1Part } from './tabs/tab-1/volunteering-prospects-tab-1.part';
import { VolunteeringProspectsTab2Part } from './tabs/tab-2/volunteering-prospects-tab-2.part';
import { VolunteeringProspectsViewsPart } from './views/volunteering-prospects-views.part';
import { VolunteeringProspectsService } from './volunteering-prospects.service';

@Component({
	selector: 'volunteering-prospects-page',
	standalone: true,
	imports: [
		VolunteeringProspectsViewsPart,
		VolunteeringProspectsTab1Part,
		VolunteeringProspectsTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-prospects.page.html',
})
export class VolunteeringProspectsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringProspectsService);
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;
	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}